import {useEffect} from 'react'
import ModalEmitir from '../../../../../components/Modals/ModalsFacturacion/ModalEmitir'
import ModalResumenFacturaEmitida from './ModalResumenFacturaEmitida'
import ModalImprimirFactura from '../../../../../components/Modals/ModalsFacturacion/ModalImprimirFactura'
import ModalEnviarEmail from '../../../../../components/Modals/ModalsFacturacion/ModalEnviarEmail'
import {State} from '../../../../../reducers'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionFacturacionEmision, actionsOperaciones} from '../../../../../actions/action-creators'
import {OPSendEmail} from '../../../../../interfaces/operaciones.interface'
import {emailInvoice} from '../../../../../utils/invoice/validateSendInvoice'
import {generalOpenModalMessage} from '../../../../../actions/general.actions'
import ModalAnularFactura2 from '../../../../../components/Modals/ModalsFacturacion/ModalAnularFactura2'
import {useHistory} from 'react-router'
import ModalConfirm from '../../../../../components/Modals/Generales/ModalConfirm'
import {
  facturacionClearAll,
  facturacionSetModalConfirmarClienteVacio,
  facturacionSetModalEmitirFactura,
} from '../../../../../actions/facturacion/facturacionEmision.actions'
import {anularFactura} from '../../../../../actions/operaciones/operaciones.actions'
import {convertDateFormatAnular} from '../../../../../utils/stringDate'
import { docsAsociadosReset } from '../../../../../actions/documentos/documentos.actions'
import { handleRestartStateFormaPago } from '../../../../../actions/forma-pago.actions'
import { unirChipsArray, unirChipsJoin, unirChipsReturnFirst } from '../../../../../utils/strings.utils'

const ModalsResumenControl = () => {
  const {
    modals,
    datosFacturaRes,
    datosEmisor,
    formCliente,
    formSucursal,
    calculosArrayProductos,
    anulado,
    impresionModoTicket,
  } = useSelector((state: State) => state.facturacion)
  const {resultAnulaciones} = useSelector((state: State) => state.historial)
  const idDoc = useSelector((state: State) => state.documentos.activeDoc?.idDoc)
  const loader = useSelector((state: State) => state.general.loader)
  const dispatch = useDispatch()
  const actionsFE = bindActionCreators(actionFacturacionEmision, dispatch)
  const {sendEmailPDF} = bindActionCreators(actionsOperaciones, dispatch)
  const history = useHistory()
  const {datos} = useSelector((state: State) => state.userLogin)

  useEffect(() => {
    if (resultAnulaciones.length > 0) actionsFE.facturacionVerificarAnulacion(funcionRedirigir)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resultAnulaciones])

  const funcionRedirigir = () => {
    history.push('/emitir-factura/formulario')
    dispatch(facturacionClearAll())
    dispatch(docsAsociadosReset())
    dispatch(handleRestartStateFormaPago())
  }

  const handleEnviarEmail = async (formEnvio: emailInvoice) => {
    if (loader) return
    const sendEmail: OPSendEmail = {
      Correo: formEnvio.email.trim(),
      Sello: datosFacturaRes?.Sello,
      IdSucursalDoc: formSucursal?.serie || "-1",
      idSucursal: datos?.sucursal_seleccionada,
      idEmpresa: `${datos?.codigo_empresa}`
    }
    if (await sendEmailPDF(sendEmail)) {
      dispatch(generalOpenModalMessage(`Enviar por email`, `El correo fue enviado exitosamente.`))
      actionsFE.facturacionOpenCloseModalEmail(false)
    }
  }

  const handleClicEmitir = () => actionsFE.facturacionClicEmitirModal(history)

  const handleAnular = async () => {
    if (anulado) return
    const anularDoc: any = {
      documento: datosFacturaRes.JsonFactura,
      sellorecibido: datosFacturaRes.Sello,
      DetallesDTE: {
        receptor: getReceptor(),
        emisor: getEmisor(),
        resumen: {
          totalIva: calculosArrayProductos.totalImpuesto1,
        },
        identificacion: {
          tipoDte: idDoc,
          codigoGeneracion: datosFacturaRes.codigoGeneracion,
          numeroControl: `DTE-${idDoc}-${formSucursal.datosSerie.serie}-${formSucursal.datosSerie.numeroactual}`,
          fecEmi: convertDateFormatAnular(datosFacturaRes.fhProcesamiento.split(' ')[0]),
        },
      },
    }
    dispatch(anularFactura([anularDoc]))
  }

  const getReceptor = () => {
    return {
      numDocumento: formCliente.numId ? formCliente.tipoDocumento === "13" ? formCliente.numId : formCliente.numId?.trim().replace(/-/g, '') : null,
      tipoDocumento: formCliente.tipoDocumento ? formCliente.tipoDocumento === "sinDocumento" ? null : formCliente.tipoDocumento : null,
      nrc: formCliente.nrc ? formCliente.nrc?.trim() : null,
      nombre: formCliente.nombre ? formCliente.nombre?.trim() : null,
      telefono: formCliente.telefono ? formCliente.telefono?.trim() : null,
      correo: unirChipsReturnFirst(formCliente.chipsEmail!, formCliente.email!) ?? null,
    }
  }
  const getEmisor = () => {
    return {
      nombre: datosEmisor.nombre,
      nit: datosEmisor.nit,
      nrc: datosEmisor.nrc,
      telefono: datosEmisor.telefono,
      correo: datosEmisor.correo,
      tipoEstablecimiento: datosEmisor.tipoestablecimiento,
    }
  }

  return (
    <>
      {modals.activeConfirmEmptyData && (
        <ModalConfirm
          title='Datos del cliente'
          detail='Los datos del cliente están vacíos, ¿deseas continuar?'
          closeModalConfirm={() => dispatch(facturacionSetModalConfirmarClienteVacio(false))}
          actionConfirm={() => dispatch(facturacionSetModalEmitirFactura(true))}
        />
      )}
      {modals.activeEmitirFactura && (
        <ModalEmitir
          ClicCancelar={actionsFE.facturacionCloseModalEmitir}
          ClicEmitir={handleClicEmitir}
          Styles={{width: '50%', maxWidth: '600px'}}
        />
      )}
      {modals.activeFacturaEmitida && <ModalResumenFacturaEmitida />}
      {modals.activeImpresion && (
        <ModalImprimirFactura
          documento={datosFacturaRes?.JsonFactura}
          sello={datosFacturaRes?.Sello}
          modoTicket={impresionModoTicket}
          onCancel={() => actionsFE.facturacionOpenCloseModalImprimir(false)}
          onPrint={() => actionsFE.facturacionOpenCloseModalImprimir(false)}
        />
      )}
      {modals.activeEmail && (
        <ModalEnviarEmail
          defaultEmail={''}
          chipsEmail={unirChipsArray(formCliente.chipsEmail!, formCliente.email!)}
          showBackBtn={true}
          onBackBtn={() => actionsFE.facturacionOpenCloseModalEmail(false)}
          onSendEmail={handleEnviarEmail}
        />
      )}
      {modals.activeAnular && (
        <ModalAnularFactura2
          closeModalEliminar={() => actionsFE.facturacionOpenCloseModalAnular(false)}
          actionEliminar={handleAnular}
          detail={`DTE-${idDoc}-${formSucursal.datosSerie.serie}-${formSucursal.datosSerie.numeroactual}`}
        />
      )}
    </>
  )
}

export default ModalsResumenControl
